import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authServies } from "../../services/authServices";
import { logoutUser } from "../Auth/authSlice";

// ? actions import
import { toogleConfirmPassword } from "../modals/modalSlice";
import { openErrorSnack, openSnackBar } from "../modals/snackBarSlice";

export const getDev = createAsyncThunk(
  "profile/dev",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const user = await authServies.http.get(`/api/user`);
      const userId = user.data.id;
      const response = await authServies.http.get(`/api/dev/${userId}`);
      // console.log(typeof id);
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
        console.log(error.response);
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error;
    }
  }
);

// ? ChangePassword Request
export const changePassword = createAsyncThunk(
  "dev/changePassword",
  async (logs, { dispatch }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.put("/api/user/password", logs);
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

// ? 2FA Authentication
export const twoFactorAuth = createAsyncThunk(
  "dev/twoFactorAuth",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        "/api/user/two-factor-authentication"
      );
      // console.log(response)

      // if (response.status === 423 && response.statusText === "Locked") {
      // dispatch(toogleConfirmPassword());
      // } else {
      // return response;
      dispatch(checkConfirmedPassword());
      // }
    } catch (error) {
      // console.log();
      if (
        error.response.status === 423 &&
        error.response.statusText === "Locked"
      ) {
        dispatch(toogleConfirmPassword());
      } else {
        return error.response;
      }

      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
    }
  }
);

// ? check if password is confirmed
export const checkConfirmedPassword = createAsyncThunk(
  "dev/checkConfirmedPassword",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(
        "api/user/confirmed-password-status"
      );
      if (response.data.confirmed === false) {
        dispatch(toogleConfirmPassword());
      } else {
        dispatch(getDev());
        return response.statusText;
      }
    } catch (error) {
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      return error.response;
    }
  }
);

// ? confirm password

export const confirmUserPassword = createAsyncThunk(
  "dev/confirmPassword",
  async (logs, { dispatch, getState }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        "/api/user/confirm-password",
        logs
      );

      //! return getState();
      // const check2fa = getState().dev.dev.has2fa;
      // const checkRecoveryCodes = getState().dev.recoveryCodes;

      // if (check2fa  && checkRecoveryCodes.length === 0) {
      //   dispatch(getRecoveryCodes);
      // } else {
      //   dispatch(twoFactorAuth());
      // }

      console.log(response.statusText);
      dispatch(toogleConfirmPassword());
      dispatch(getDev());
      // return response.statusText;
      // dispatch(twoFactorAuth());
    } catch (error) {
      if (
        error.response.status === 422 &&
        error.response.statusText === "Unprocessable Content"
      ) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data.message;
      } else {
        return error.response.statusText;
      }
    }
  }
);

// ? get QRCodes
export const getQrCode = createAsyncThunk(
  "dev/getQrCode",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(
        "api/user/two-factor-qr-code"
      );
      return response;
    } catch (error) {
      if (
        error.response.status === 423 &&
        error.response.statusText === "Locked"
      ) {
        dispatch(checkConfirmedPassword());
      } else {
        return error.response;
      }
    }
  }
);

// ? get RecoveryCodes
export const getRecoveryCodes = createAsyncThunk(
  "dev/recoveryCodes",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(
        "api/user/two-factor-recovery-codes"
      );
      return response;
    } catch (error) {
      if (
        error.response.status === 423 &&
        error.response.statusText === "Locked"
      ) {
        dispatch(checkConfirmedPassword());
      } else {
        return error.response;
      }
    }
  }
);

// ? Regenerate Recovery Codes
export const regenerateRecoveryCodes = createAsyncThunk(
  "dev/regenerateRecoveryCodes",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        "api/user/two-factor-recovery-codes"
      );
      dispatch(getRecoveryCodes());
      // return response;
    } catch (error) {
      if (
        error.response.status === 423 &&
        error.response.statusText === "Locked"
      ) {
        dispatch(checkConfirmedPassword());
      } else {
        return error.response;
      }
    }
  }
);

// ? Delete Two Factor Authentication

export const deleteTwoFactoAuthentication = createAsyncThunk(
  "dev/deleteTwoFactoAuthentication",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.delete(
        "/api/user/two-factor-authentication"
      );
      dispatch(checkConfirmedPassword());
    } catch (error) {
      if (
        error.response.status === 423 &&
        error.response.statusText === "Locked"
      ) {
        dispatch(checkConfirmedPassword());
      } else {
        return error.response;
      }
    }
  }
);

// ? Update profile info Request
export const profileInformation = createAsyncThunk(
  "auth/profileInformation",
  async (data, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.put(
        "/api/user/profile-information",
        data
      );
      dispatch(getDev());
      dispatch(openSnackBar({ message: "profile updated successfully" }));

      return response.statusText;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
      }
      return error.response;
    }
  }
);

const initialState = {
  dev: {},
  succuss: false,
  pending: false,
  errorMsg: {},
  qrCode: "",
  recoveryCodes: [],
};

const devSlice = createSlice({
  name: "devSlice",
  initialState,
  reducers: {},
  extraReducers: {
    // ? get Current Dev info
    [getDev.pending]: (state, action) => {
      state.pending = true;
    },
    [getDev.fulfilled]: (state, action) => {
      state.pending = false;

      const user = action.payload;
      console.log(user);
      state.dev = user.data.data;
    },
    [getDev.rejected]: (state, action) => {
      state.pending = false;

      console.log(action.payload);
    },

    // ? change current dev password
    [changePassword.pending]: (state, action) => {
      state.pending = true;

      console.log(action.payload);
    },
    [changePassword.fulfilled]: (state, action) => {
      state.pending = false;

      const change = action.payload;
      console.log(change);
    },
    [changePassword.rejected]: (state, action) => {
      state.pending = false;

      console.log(action);
    },

    // ? Enabale Two factor Auth
    [twoFactorAuth.pending]: (state, action) => {
      state.pending = true;

      console.log(action.payload);
    },
    [twoFactorAuth.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);

      // if (result.status === 423 && result.statusText === "Locked") {
      //   state.errorMsg.confirmPassword = result.data.message;
      //   console.log(state.errorMsg);
      // }
    },
    [twoFactorAuth.rejected]: (state, action) => {
      state.pending = false;

      console.log(action.payload);
    },

    // ? Check for password Confirmationation Status
    [checkConfirmedPassword.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [checkConfirmedPassword.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [checkConfirmedPassword.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },

    // ? confirm password action
    [confirmUserPassword.pending]: (state, action) => {
      state.pending = true;

      console.log(action.payload);
    },
    [confirmUserPassword.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      // if (result.status === 422) {
      //   state.errorMsg = result.data.message;
      // }
      console.log(result);
      // if (result) {
      //   state.errorMsg = result;
      // }
    },
    [confirmUserPassword.rejected]: (state, action) => {
      state.pending = false;

      console.log(action.payload);
    },

    // ? Get Qrcode svg action
    [getQrCode.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getQrCode.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.qrCode = result.data.svg;
      console.log(result);
    },
    [getQrCode.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },

    // ? Get recoveryCodes
    [getRecoveryCodes.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getRecoveryCodes.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.recoveryCodes = result.data;
      console.log(result);
    },
    [getRecoveryCodes.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },

    // ? Get Renerated RecoveryCodes
    [regenerateRecoveryCodes.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [regenerateRecoveryCodes.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.recoveryCodes = result.data;
      console.log(result);
    },
    [regenerateRecoveryCodes.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },

    // ? Delete TwoFactorAuthentication

    [deleteTwoFactoAuthentication.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [deleteTwoFactoAuthentication.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [deleteTwoFactoAuthentication.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },

    // ? update user profile infomation
    [profileInformation.pending]: (state, action) => {
      state.pending = true;

      console.log(action.payload);
    },
    [profileInformation.fulfilled]: (state, action) => {
      state.pending = false;

      console.log(action.payload);
      const dev = action.payload.data;
      // state.dev = dev;
    },
    [profileInformation.rejected]: (state, action) => {
      state.pending = false;

      console.log(action.payload);
    },
  },
});

export default devSlice.reducer;
